import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { BoardConfig, resolveBoardConfig } from '../depatureboard/board-config';

@Component({
  selector: 'app-depatureboard-page',
  templateUrl: './depatureboard-page.component.html',
  styleUrls: ['./depatureboard-page.component.css']
})
export class DepatureboardPageComponent implements OnInit, OnDestroy {
  config: BoardConfig = resolveBoardConfig({}, '');

  private queryParamsSubscription?: Subscription;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe((params) => {
      this.config = resolveBoardConfig(params, '');
    });
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
  }
}
